import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {AgeAuthVo} from '../../common/shared/api/nicolas/vo/AgeAuthVo.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 연령 인증 정보 조회
 *
 * Origin: pageNicolasApi.getAgeAuth
 * API: POST /api/v2/user/get/age_auth
 */
export async function postGatewayUserGetAgeAuth(
  ageLimit: number,
  options?: FetcherOptions
): Promise<ApiResultVo & AgeAuthVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v2/user/get/age_auth',
    {
      method: 'POST',
      data: {age_limit: ageLimit},
    },
    options
  );
  return response.data;
}
